if (!customElements.get("section-calculateur-solaire")) {
  customElements.define(
    "section-calculateur-solaire",
    class SectionCalculateurSolaire extends HTMLElement {
      constructor() {
        super();
        this.range = this.querySelector("input[type=range]");
        this.bubble = this.querySelector(".range-slider-cursor");
        this.resultValue = this.querySelector(".solar-calculator__result-value");
        
        if (!this.range || !this.bubble || !this.resultValue) return;
        
        this.benefitValue = parseFloat(this.resultValue.dataset.value) || 25;
        
        this.range.addEventListener("input", this.onInputHandler.bind(this));
        this.bubble.textContent = this.range.value;
        this.updateResult(this.range.value);
        this.onInputHandler({ target: this.range });
      }
      
      onInputHandler(evt) {
        this.bubble.innerHTML = evt.target.value;
        
        const container = this.range.closest('.input-number');
        const containerWidth = container ? container.offsetWidth : this.range.offsetWidth;
        const padding = 20;
        const thumbWidth = 60;
        const availableWidth = containerWidth - (padding * 2) - thumbWidth;
        const max = parseInt(this.range.max) || 10;
        const min = parseInt(this.range.min) || 1;
        const percentage = (evt.target.value - min) / (max - min);
        const xPX = padding + (percentage * availableWidth);
        this.bubble.style.left = `${xPX}px`;
        this.updateResult(evt.target.value);
      }
      
      updateResult(value) {
        if (!this.resultValue) return;
        
        const totalValue = this.benefitValue * value;
        const displayValue = totalValue.toLocaleString('fr-FR');
        
        this.resultValue.innerHTML = `+${displayValue}€`;
      }
    }
  );
}
